export default function getInitialState() {
  return {
    isScreenshareSupported: false,
    hasScreensharePermissions: true,
    screenshareSources: []
  };
}
